export default {
  EMAIL: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i,
  IOT_THING_NAME: /^[a-z0-9:\-_\s]+$/i,
  PLAN_KEY: /^[A-Z0-9]+$/,
  LAST_JOB_INDEX: /^[0-9]+$/,
  TIMEZONE: /([+-]([0-9]|1[0-1]):[0-5][0-9])|\+12:00|\+13:00/
};
